import { useQuery, UseQueryOptions } from 'react-query';

import useStore, { VerificationState } from 'app/hooks/useStore';
import { getGuestDataByLocator } from 'app/services/GuestCenterService';
import { QueryKeys } from 'app/services/QueryClient';

export const queryKey = QueryKeys.GuestDataByLocator;

export default function useGuestDataQueryByLocator({
  notifyOnChangeProps,
  locator,
  enabled = true,
}: {
  notifyOnChangeProps?: UseQueryOptions['notifyOnChangeProps'];
  locator: string | undefined;
  enabled?: boolean;
}) {
  const { email, verificationState, user } = useStore((s) => ({
    email: s.email,
    verificationState: s.verificationState,
    user: s.user,
  }));
  const isCitypassUser = email?.endsWith('@citypass.com') || user?.email?.endsWith('@citypass.com');

  return useQuery([queryKey, email, locator], () => getGuestDataByLocator(locator), {
    enabled:
      !!email && !!user && verificationState === VerificationState.Verified && !!locator && enabled,
    notifyOnChangeProps,
    refetchOnMount: false,
    refetchOnWindowFocus: isCitypassUser ? 'always' : true,
  });
}
